<template>

<div class="checklist-item d-flex mb-2">
    <i class="fas fa-check-circle text-success mr-2 mt-1" />
    <div>
      <div class="text-muted small">{{ label }}</div>
      <div class="d-flex pt-2" style="gap: 10px;">
        <div v-for="type in types" :key="type.label" :class="['badge', statusClass(type.status)]">
          {{ type.label }}
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    label: String,
    broker: String,
    common: String,
    contract: String,
  },
  computed: {
    types() {
      return [
        { label: 'BROKER', status: this.broker },
        { label: 'COMMON', status: this.common },
        { label: 'CONTRACT', status: this.contract },
      ];
    },
  },
  methods: {
    statusClass(status) {
      if (!status || status === 'N') return 'badge--inactive';
      if (status === 'A') return 'badge--active';
      if (status === 'O') return 'badge--pending';
      return 'badge--unknown';
    }
  }
};
</script>

<style scoped>
.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-weight: bold;
}
.badge--active {
  background-color: #d4f4dd;
  color: #0f5132;
}
.badge--inactive {
  background-color: #e9ecef;
  color: #6c757d;
}
.badge--pending {
  background-color: #fff3cd;
  color: #856404;
}
.badge--unknown {
  background-color: #f8d7da;
  color: #721c24;
}
</style>
